import { TrackProperties } from "../../../pages/DAW/types";
import { useEffect, useState } from "react";
import { AudioFileTrackProperties } from "../../../pages/DAW/types";

type ReturnType = {
  track: AudioFileTrackProperties;
  handleNameChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  handlePanChange: (newValue: number) => void;
  handleMuteChange: () => void;
  handleSoloChange: () => void;
  handleVolumeChange: (newValue: number) => void;
  setPlayerAsLoaded: () => void;
  setTrackUrl: any;
  setDuration: any;
};

const useDnDTrack = (trackProperties: TrackProperties): ReturnType => {
  const [track, setTrack] = useState<AudioFileTrackProperties>({
    ...trackProperties,
  });

  useEffect(() => {
    if (trackProperties.trackFinished !== track.trackFinished)
      setTrack((prev) => ({
        ...prev,
        trackFinished: trackProperties.trackFinished,
      }));
  }, [track.trackFinished, trackProperties.trackFinished]);

  const setTrackUrl = (url: string) => {
    setTrack((prev) => ({ ...prev, url }));
  };

  const setPlayerAsLoaded = () => {
    setTrack((prev) => ({ ...prev, isPlayerLoaded: true }));
  };
  const setDuration = (duration: number) => {
    setTrack((prev) => ({ ...prev, duration }));
  };

  const handleNameChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setTrack((prev) => ({ ...prev, name: event.target.value }));
  };

  const handlePanChange = (newValue: number) => {
    setTrack((prev) => ({ ...prev, pan: newValue / 100 }));
  };

  const handleMuteChange = () => {
    setTrack((prev) => ({ ...prev, mute: !prev.mute }));
  };

  const handleSoloChange = () => {
    setTrack((prev) => ({ ...prev, solo: !prev.solo }));
  };

  const handleVolumeChange = (newValue: number) => {
    let modifiedValue: number;
    if (newValue < 0) modifiedValue = 0;
    else if (newValue > 100) modifiedValue = 100;
    else modifiedValue = Math.round(newValue);
    setTrack((prev) => ({ ...prev, volume: modifiedValue }));
  };

  return {
    track,
    handleNameChange,
    handlePanChange,
    handleMuteChange,
    handleSoloChange,
    handleVolumeChange,
    setTrackUrl,
    setPlayerAsLoaded,
    setDuration,
  };
};

export default useDnDTrack;
